//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        fromDate: null,
        toDate: null,
      },
    };
  },

  computed: {
    ...mapState('userReferralReferrals', ['filterLists']),
  },

  watch: {
    filters: {
      async handler(data) {
        const protocol = this.$utils.getAppType() === 'p2pay' ? this.setNew : this.setOld;
        await protocol(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('userReferralReferrals', {
      setOld: 'setFilters',
    }),
    ...mapActions('referrals', {
      setNew: 'setFilters',
    }),
  },
};
